<div class="modal-header">
    <h5 class="modal-title">Bildirim Görüldü Bilgisi</h5>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <table class="table table-striped mb-0">
        <thead class="thead-light">
            <tr>
                <th scope="col">İsim Soyisim</th>
                <th scope="col" class="text-center">Durum</th>
                <th scope="col" class="text-center">Görülme Tarihi</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of hasReaderUsersData">
                <td>{{ item.name }} {{ item.lastName }}</td>
                <td class="text-center">
                    <span class="badge" [ngClass]="item.isRead ? 'badge-success' : 'badge-secondary'">
                        {{ item.isRead ? 'Gördü' : 'Görülmedi' }}
                    </span>
                </td>
                <td>{{item.readAt | date:'dd.MM.yyyy HH:mm'}}</td>
            </tr>
        </tbody>
    </table>
</div>